export const validateAgePhoneCloudImportFile = (keys: string[]) => {
  let result: string = "";
  if (!keys.includes('username') && !keys.includes('id')) {
    result += "\r\nフィールド「username」、または「id」が不足しています。";
  }
  if (!keys.includes('first_name')) {
    result += "\r\nフィールド「first_name」が不足しています。";
  }
  if (!keys.includes('last_name')) {
    result += "\r\nフィールド「last_name」が不足しています。";
  }
  if (!keys.includes('phonetic_first_name')) {
    result += "\r\nフィールド「phonetic_first_name」が不足しています。";
  }
  if (!keys.includes('phonetic_last_name')) {
    result += "\r\nフィールド「phonetic_last_name」が不足しています。";
  }
  if (!keys.includes('title')) {
    result += "\r\nフィールド「title」が不足しています。";
  }
  if (!keys.includes('department')) {
    result += "\r\nフィールド「department」が不足しています。";
  }
  if (!keys.includes('organization')) {
    result += "\r\nフィールド「organization」が不足しています。";
  }
  if (!keys.includes('email')) {
    result += "\r\nフィールド「email」が不足しています。";
  }
  if (!keys.includes('alt_email')) {
    result += "\r\nフィールド「alt_email」が不足しています。";
  }
  if (!keys.includes('phone')) {
    result += "\r\nフィールド「phone」が不足しています。";
  }
  if (!keys.includes('mobile')) {
    result += "\r\nフィールド「mobile」が不足しています。";
  }
  if (!keys.includes('extension')) {
    result += "\r\nフィールド「extension」が不足しています。";
  }
  if (!keys.includes('fax')) {
    result += "\r\nフィールド「fax」が不足しています。";
  }
  if (!keys.includes('street1')) {
    result += "\r\nフィールド「street1」が不足しています。";
  }
  if (!keys.includes('street2')) {
    result += "\r\nフィールド「street2」が不足しています。";
  }
  if (!keys.includes('city')) {
    result += "\r\nフィールド「city」が不足しています。";
  }
  if (!keys.includes('state')) {
    result += "\r\nフィールド「state」が不足しています。";
  }
  if (!keys.includes('zipcode')) {
    result += "\r\nフィールド「zipcode」が不足しています。";
  }
  if (!keys.includes('country')) {
    result += "\r\nフィールド「country」が不足しています。";
  }

  return result;
}
